import Link from "next/link";
import { LogoMark, LogoWordmark } from "../Navbar";

export default function AuthCard({
  title,
  subtitle,
  footer,
  children,
}: {
  title: string;
  subtitle: string;
  footer: { label: string; href: string; text: string };
  children: React.ReactNode;
}) {
  return (
    <main className="app-auth-page">
      <div className="app-auth-shell">
        <Link href="/" className="app-auth-logo">
          <LogoMark className="app-auth-mark" />
          <LogoWordmark />
        </Link>
        <section className="app-auth-card">
          <div className="app-auth-head">
            <p className="app-auth-eyebrow">
              Acceso Vilatio
            </p>
            <h1 className="app-auth-title">
              {title}
            </h1>
            <p className="app-auth-subtitle">{subtitle}</p>
          </div>
          {children}
          <p className="app-auth-footer">
            {footer.text}{" "}
            <Link className="app-auth-footer-link" href={footer.href}>
              {footer.label}
            </Link>
          </p>
        </section>
      </div>
    </main>
  );
}
